import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-section-title2',
  templateUrl: './section-title2.component.html',
  styleUrls: ['./section-title2.component.scss']
})
export class SectionTitle2Component implements OnInit {

  @Input() title;
  @Input() color: 'danger' | 'white'| 'dark' = 'danger';
  @Input() addSpacer = false;
  @Input() hasBorder = true;

  constructor() {
  }

  ngOnInit() {
  }

}
